
import "../css/Home.css";

import { useEffect, useState } from "react";

import htmlParser from "html-react-parser";

import { Header } from './../common/Header';
import { PreOrder, Ellipses, FeatureComingSoon } from './../common/Components';

import { fromCamelCaseToCapitalizedSpaced, toKebabCase } from "../utilities/helpers";

import siteTeaser from "./../assets/img/site-teaser.png";
import VideoPlayer from "../common/VideoPlayer";

import { usePlatform } from "../context/PlatformContext";
import { useSubjectsMetadata } from "../context/SubjectsMetadataContext";




export { Home };

function Home() {

  const { platform } = usePlatform();

  return (
    <>
      {
        platform ? 
          <>
            <Header content={<HeaderContent />} />

            <Main />
          </>
        :
          <div className="loading">loading...</div> /*TODO: Proper loading Component (throughout App)*/
      }
    </>
  );
}


function HeaderContent() {

  const { platform } = usePlatform();

  if( !platform ) return null;


  return (
    <div className="home-header_content">
      <div className="home-header_content_call-to-action">
        <div className="home-header_content_call-to-action_container">
          <h2 className="home-header_content_slogan">
            {
              platform.hero.sloganLines.map( (line: string, index: number) => (
                <span key={index}>{line}<br/></span>
              ))
            }
            {/*
            Insight That Guides<br/>
            Experience That Empowers<br/>
            Impact That Lasts
            */}
          </h2>
          <button className="home-header_content_purchase_button home-button">
            <FeatureComingSoon />
            {platform.hero.cta.text}
          </button>
        </div>
      </div>

      <div className="home-header_content_teaser-container">
        <img src={siteTeaser} alt="Site Teaser" className="home-header_content_teaser" />
      </div>
    </div>
  );
}


function Main() {

  const { platform } = usePlatform();

  if( !platform ) return null;


  return (
    <main className="platform_body site-home_body">
      <div className="site-home_body_catch-phrase_container">
        <h2 className="site-home_body_catch-phrase">
          {platform.valueProposition.headline}
        </h2>
      </div>

      <IntroVideo />

      <PlatformFeatures />

      <PlatformCourses />

    </main>
  );
}


function IntroVideo() {

  const [showVideoOverlay, toggleVideoOverlay] = useState( false );

  const { platform } = usePlatform();
  if( !platform ) return null;

  const toggleVideo = () => {
    toggleVideoOverlay( !showVideoOverlay );
  };

  return (
    <div className="site-home-body_intro-video_container">
      <h2 className="site-home-body_intro-video_heading site-home_platform-overview_title">What is {platform.brand.name}?</h2>

      <div className="site-home-body_intro-video">
        <VideoPlayer videoURL={platform.intro.videoURL} />
      </div>

      <div className="site-home-body_intro-video_button_container">
        <button className="site-home-body_intro-video_button" onClick={() => toggleVideo()}>
          { showVideoOverlay && (
            <>
              <div className="site-home-body_overlay_intro-video">
                <VideoPlayer videoURL={""} />
              </div>

              <div className="screen-overlay" onClick={toggleVideo} ></div>
            </>
          )}
          {/* TODO: Play Icon Symbol */}
          <span className="site-home-body_intro-video_button_text">Watch the Video</span>
        </button>
      </div>
    </div>
  );
}

function PlatformFeatures() {

  const { platform } = usePlatform();

  if( !platform || !platform.features ) return null;

  return (
    <div className="site-home_platform-features_container">
      <h2 className="site-home_platform-overview_title">Features</h2>
      <div className="site-home_platform-features">

        {
          platform.features.map( (feature: any, index: number) => (
            <PlatformFeature
              key={index}
              title={feature.title}
              description={feature.description} />
          ))
        }
      </div>
    </div>
  );
}

function PlatformFeature( {title, description}: {title: string, description: string} ) {

  // TODO: HAVE ICON ASSOCIATED WITH EACH? (i.e. before Heading, having Icon?)
  return (
    <div className="site-home_platform-feature">
      <h3 className="site-home_platform-feature_title">{title}</h3>
      <p className="site-home_platform-feature_description">{description}</p>
    </div>
  );
}

function PlatformCourses() {

  const { platform } = usePlatform();

  const { foundationSubjectsMetadata, specialtySubjectsMetadata } = useSubjectsMetadata();

  const [ programSnippets, setProgramSnippets ] = useState<any[]>( [] );

  useEffect( () => {
    if( foundationSubjectsMetadata || specialtySubjectsMetadata ) {
      const allSubjectsMetadata = [...foundationSubjectsMetadata, ...specialtySubjectsMetadata];

      const programs = allSubjectsMetadata.reduce( (acc: any, subjectMetadata: any) => {
        const subjectPrograms = subjectMetadata.programs.map( (program: any) => {
          return {
            programSelector: program.selector,
            subjectType: subjectMetadata.type,
            subjectSelector: program.subjectSelector,

            description: program.description,
            preOrder: !program.published && program.canPreOrder
          };
        });

        acc.push( ...subjectPrograms );

        return acc;
      }, []);

      console.log( programs );

      if( programs && programs.length > 0 ) { 
        setProgramSnippets( [...programs] );
      }
    }
  }, [foundationSubjectsMetadata, specialtySubjectsMetadata]);

  if( !platform ) return null;


  return (
    <div className="site-home_platform-courses_container">

      { programSnippets && programSnippets.length > 0 && (
        <>
          <h2 className="site-home_platform-overview_title">Courses</h2>
          <div className="site-home_platform-courses">

            {programSnippets.map( (programSnippet: any, index: number) => (
              <PlatformCourse
                key={index}
                programSelector={programSnippet.programSelector}
                subjectSelector={programSnippet.subjectSelector}
                subjectType={programSnippet.subjectType}
                description={programSnippet.description}
                isComingSoon={programSnippet.preOrder} />
            ))}
          </div>
        </>
      )}

      {
        platform.upcomingContentTeaser && (
          <>
            <Ellipses />

            <p className="site-home_platform-courses_foreshadowing">
              {
                platform.upcomingContentTeaser.teaserLines.map( (line: string, index: number) => (
                  <span key={index}>{htmlParser(line)}<br/></span>
                ))
              }
            </p>
            <hr/>
            <h3><u><strong>YOU have a say</strong></u></h3>
            <p className="site-home_platform-courses_foreshadowing">
              {platform.communityInput.descriptionLines.map( (line: string, index: number) => (
                <span key={index}>{htmlParser(line)}<br/></span>
              ))}
            </p>

            <button className="site-home_platform-courses_planned_button home-button">
              <FeatureComingSoon />
              {platform.communityInput.cta.text}
            </button>
          </>
        )
      }

    </div>
  );
}

function PlatformCourse( {programSelector, subjectSelector, subjectType, description, isComingSoon}: {programSelector: string, subjectSelector: string, subjectType: string, description: string, isComingSoon: Boolean}) {

  const subjectKebab = toKebabCase(subjectSelector);
  const programKebab = toKebabCase(programSelector);
  const url = `/content/${subjectType}/${subjectKebab}/${programKebab}/course`;

  return (
    <div className="platform_content_grid_card site-home_platform-course">
      {isComingSoon && <PreOrder />}
      <a href={url} className="site-home_platform-course_link">
        <h3 className="site-home_platform-course_title">
          {fromCamelCaseToCapitalizedSpaced(subjectSelector)}
          <br/>
          {fromCamelCaseToCapitalizedSpaced(programSelector)}
        </h3>
        <p className="site-home_platform-course_description">{description}</p>
      </a>
    </div>
  );
}




